import Validators from './validators';
import { isFileList } from './file';
import { prepareMsg, prepare, memoize } from './helpers';
import typeUtils from '../type';

const presence = memoize(({ message, msg, if: ifCond, unless } = {}) => {
	msg = msg || message;

	return prepare(ifCond, unless, false, (value) => {
		const isValueInvalidString = typeof value === 'string' && !value.trim();
		const isValueInvalidArray = Array.isArray(value) && value.length === 0;
		const isValueInvalidFileList = isFileList(value) && !value.length;
		const isValueEmpty = typeUtils.isNullOrUndefined(value);

		if (isValueInvalidString || isValueInvalidArray || isValueInvalidFileList || isValueEmpty) {
			return Validators.formatMessage(prepareMsg(msg, 'presence'));
		}
	});
});

export default presence;
